import React, { useState, useEffect } from 'react';
import './login.css';
import { 
    useParams,
    useNavigate } 
    from "react-router-dom";
import axios from 'axios';
import SftGlobalData from '../../library/SftGlobalData';
import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';

import logo_light from '../../assets/header/logo_light.png';
import logo_dark from '../../assets/header/logo_dark.png';
import logo_light_halloween from '../../assets/header/logo_light_halloween.png';
import logo_dark_halloween from '../../assets/header/logo_dark_halloween.png';
import '../../styles/main.css';

import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle, faApple } from '@fortawesome/free-brands-svg-icons';
import crypto from 'crypto-js';


const LoginScreen = (props) =>  {
    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [attempts, setAttempts] = useState(0);
    const [loggedIn, setLoggedIn] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);    
    const params = useParams();
    let navigate = useNavigate();

    //---------------------------------------------------------------------------------------------
    //    FUNCTIONS
    //---------------------------------------------------------------------------------------------

    const getLogo = () => {
        switch(props?.holiday){
            case "halloween": return (props.theme==='dark') ? logo_dark_halloween : logo_light_halloween;
            default: return (props.theme==='dark') ? logo_dark : logo_light;
        }
      }

    const handleSubmit = (event) => {        
        event.preventDefault();
        setLoading(true);

        if(user === '' || password === ''){
            props.notify(props.t('missing_fields'), 7500, "top-center", props.theme, 1); 
            setLoading(false);
        } else if(attempts >= 3) {
            props.notify(props.t('too_many_attempts'), 7500, "top-center", props.theme, 1); 
            setLoading(false);
        }else {
            setAttempts(attempts + 1);
            let APIurl = SftGlobalData.baseURL_API + 'login';
            let postData = {
                login: user, 
                password: crypto.MD5(JSON.stringify(password)).toString()
            };
            axios.post(APIurl, postData, {
                headers : {
                    'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
                }})
                .then(response => {
                    if(SftGlobalData.debug){
                        console.log('url', APIurl);
                        console.log('data', postData);
                        console.log('response', response);
                        console.log('response error', typeof response.error);
                    }
                    if(typeof response.error === 'undefined'){
                        if(!response.data.is_valid){
                            props.notify(props.t('invalid_credentials'), 7500, "top-center", props.theme, 1); 
                            setLoading(false);
                        } else {
                            setAttempts(0);
                            props.cacheLogin(response.data); 
                            props.useDbs(response.data.dbs);
                            setLoggedIn(true); 
                        }
                    } else { 
                        props.notify(props.t('errorOccured'), 7500, "top-center", props.theme, 1);                      
                        setLoading(false);
                    }
                })
        }
    };

    useEffect(() => {
        if (loggedIn){
            props.changeScreen('environment');
            return navigate("/"+props.lang+"/environment");
        } else {
            props.changeScreen('login');
        }
     },[loggedIn]);

     useEffect(() => {
        if(params.error){
            props.notify(props.t('resetTokenExpired'), 7500, "top-center", props.theme, 1); 
            console.log("params", params);
            navigate("/"+props.lang+"/login");
        }        
     },[params.error, props.lang, props.theme]);

    const forgotPassword = () => {
        if(user === ''){
            props.notify(props.t('missing_fields'), 7500, "top-center", props.theme, 1); 
            setLoading(false);
        }else if(!user.includes('@') || !user.includes('.')){
            props.notify(props.t('invalid_email'), 7500, "top-center", props.theme, 1);
        }else {
            setLoading(true);
            let postData = {
                login: user
            };
            SftGlobalData.post('user&action=resetToken', postData).then(response => {
                if(response?.success){
                    props.notify(props.t('succes'), 7500, "top-center", props.theme, 1); 
                    setLoading(false);
                } else { 
                    props.notify(props.t('errorOccured'), 3000, "top-center", props.theme, 1);                 
                    setLoading(false);
                }
            })
        }
    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleGoogleLogin = () => {
        console.log('Google login clicked - starting OAuth flow');

        // Check if Google Identity Services is loaded
        if (typeof window.google === 'undefined') {
            props.notify('Google login service not available', 3000, "top-center", props.theme, 1);
            return;
        }

        setLoading(true);

        // Initialize Google Identity Services
        window.google.accounts.id.initialize({
            client_id: SftGlobalData.google_client_id,
            callback: handleGoogleResponse,
            auto_select: false,
            cancel_on_tap_outside: true
        });

        // Show the Google login prompt
        window.google.accounts.id.prompt((notification) => {
            if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
                // Fallback: render the Google Sign-In button if prompt failed
                renderGoogleButton();
            }
        });
    };

    const handleGoogleResponse = (response) => {
        console.log('Google OAuth response received');

        // The response.credential contains the JWT ID token
        const googleToken = response.credential;

        if (!googleToken) {
            props.notify('Google authentication failed', 3000, "top-center", props.theme, 1);
            setLoading(false);
            return;
        }

        // Send the Google token to our backend
        let APIurl = SftGlobalData.baseURL_API + 'oauth&action=google';
        let postData = {
            google_token: googleToken,
            app_id: 1
        };

        axios.post(APIurl, postData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        })
        .then(response => {
            if (SftGlobalData.debug) {
                console.log('OAuth API url', APIurl);
                console.log('OAuth API data', postData);
                console.log('OAuth API response', response);
            }

            if (typeof response.error === 'undefined' && response.data && response.data.is_valid) {
                setAttempts(0);
                props.cacheLogin(response.data);
                props.useDbs(response.data.dbs);
                setLoggedIn(true);
            } else {
                const errorMessage = response.data?.error || 'OAuth authentication failed';
                props.notify(errorMessage, 7500, "top-center", props.theme, 1);
                setLoading(false);
            }
        })
        .catch(error => {
            console.error('OAuth API error:', error);
            props.notify('Network error during Google login', 7500, "top-center", props.theme, 1);
            setLoading(false);
        });
    };

    const renderGoogleButton = () => {
        // This is a fallback method to render a button if the prompt doesn't work
        window.google.accounts.id.renderButton(
            document.getElementById("google-signin-button"),
            {
                theme: props.theme === 'dark' ? 'filled_black' : 'outline',
                size: 'large',
                width: 300 // Fixed width instead of percentage
            }
        );
    };

    const handleAppleLogin = () => {
        console.log('Apple login clicked - starting OAuth flow');

        // Check if Apple Sign-In is loaded
        if (typeof window.AppleID === 'undefined') {
            props.notify('Apple login service not available', 3000, "top-center", props.theme, 1);
            return;
        }

        setLoading(true);

        // Initialize Apple Sign-In
        window.AppleID.auth.init({
            clientId: SftGlobalData.apple_client_id,
            scope: 'name email',
            redirectURI: window.location.origin + '/auth/apple/callback',
            state: 'mysofttouch-login',
            usePopup: true
        });

        // Start Apple Sign-In
        window.AppleID.auth.signIn()
            .then(handleAppleResponse)
            .catch(error => {
                console.error('Apple Sign-In error:', error);
                props.notify('Apple login failed', 3000, "top-center", props.theme, 1);
                setLoading(false);
            });
    };

    const handleAppleResponse = (response) => {
        console.log('Apple OAuth response received');

        // The response contains the authorization code and ID token
        const appleToken = response.authorization.id_token;

        if (!appleToken) {
            props.notify('Apple authentication failed', 3000, "top-center", props.theme, 1);
            setLoading(false);
            return;
        }

        // Send the Apple token to our backend
        let APIurl = SftGlobalData.baseURL_API + 'oauth&action=apple';
        let postData = {
            apple_token: appleToken,
            app_id: 1
        };

        axios.post(APIurl, postData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        })
        .then(response => {
            if (SftGlobalData.debug) {
                console.log('Apple OAuth API url', APIurl);
                console.log('Apple OAuth API data', postData);
                console.log('Apple OAuth API response', response);
            }

            if (typeof response.error === 'undefined' && response.data && response.data.is_valid) {
                setAttempts(0);
                props.cacheLogin(response.data);
                props.useDbs(response.data.dbs);
                setLoggedIn(true);
            } else {
                const errorMessage = response.data?.error || 'Apple OAuth authentication failed';
                props.notify(errorMessage, 7500, "top-center", props.theme, 1);
                setLoading(false);
            }
        })
        .catch(error => {
            console.error('Apple OAuth API error:', error);
            props.notify('Network error during Apple login', 7500, "top-center", props.theme, 1);
            setLoading(false);
        });
    };

    const handleFacebookLogin = () => {
        console.log('Facebook login clicked - integration pending');
        props.notify('Facebook login integration coming soon!', 3000, "top-center", props.theme, 0);
    };

    //---------------------------------------------------------------------------------------------
    //    OUTPUT
    //---------------------------------------------------------------------------------------------

    return (
        <div>
            <div className='login__ fade-scale-in'>
                <form onSubmit={handleSubmit}>
                    <fieldset className={props.theme+' login__form login__form_' + props.theme}>
                        <img alt='SoftTouch Logo' src={getLogo()} className='login__logo logo-fade-in'/>
                        <br/> 

                        <FormControl sx={{ m: 1, width: '100%', margin: '0', marginBottom: '10px' }} className="scale-up-center-2">
                            <OutlinedInput
                                type='email'
                                name="txt_user"
                                onChange={(event)=>{setUser(event.target.value)}}
                                id="txt_user"
                                className={props.theme+"_accent"}
                                value={user}
                                placeholder={props.t('username')}
                            />
                        </FormControl>

                        <FormControl sx={{ m: 1, width: '100%', margin: '0' }} className="scale-up-center-3">
                            <OutlinedInput
                                id="outlined-adornment-password"
                                type={showPassword ? 'text' : 'password'}
                                name="txt_password"
                                className={props.theme+"_accent"}
                                value={password}
                                onChange={(event)=>{setPassword(event.target.value)}}
                                placeholder={props.t('password')}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                        >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        <div className='login__buttons scale-up-center-4'>
                            <LoadingButton
                                    loading={loading}
                                    type="submit"
                                    className='login__button hover-scale hover-shadow'
                                    size="large"
                                    >
                                    {!loading && props.t('login')}
                            </LoadingButton>
                            {!loading && <Button
                                onClick={() => {
                                    forgotPassword();
                                }}
                                className={'login_forgotpass__button_'+props.theme}
                            >
                            {props.t('forgot_password')}
                            </Button>}
                        </div>

                        <div className="login__divider scale-up-center-5">
                            <span className="login__divider-text">{props.t('or')}</span>
                        </div>

                        <div className="login__social-buttons">
                            <Button
                                onClick={handleGoogleLogin}
                                className="social-button google-button scale-up-center-6 hover-scale"
                                variant="outlined"
                                size="large"
                                startIcon={<FontAwesomeIcon icon={faGoogle} />}
                                disabled={loading}
                            >
                                {props.t('continue_with_google') || 'Continue with Google'}
                            </Button>
                            {/* Fallback div for Google Sign-In button */}
                            <div id="google-signin-button" style={{display: 'none'}}></div>

                            <Button
                                onClick={handleAppleLogin}
                                className="social-button apple-button scale-up-center-7 hover-scale"
                                variant="outlined"
                                size="large"
                                startIcon={<FontAwesomeIcon icon={faApple} />}
                                disabled={loading}
                            >
                                {props.t('continue_with_apple') || 'Continue with Apple'}
                            </Button>

                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    );
}

export default LoginScreen;